import React from "react";
import { Box, Typography } from "@mui/material";
import { ActionModal, NoticeboardButton } from "../shared";
import {
  buildManualReminderTitle,
  MANUAL_REMINDER_BODY_INTRO,
} from "../../utils/noticeManualReminder";

interface SendReminderModalProps {
  open: boolean;
  onClose: () => void;
  noticeTitle: string;
  /** When set, reminder is sent to this parent only. */
  recipientName?: string;
  onConfirm: () => void;
  loading?: boolean;
}

const SendReminderModal: React.FC<SendReminderModalProps> = ({
  open,
  onClose,
  noticeTitle,
  recipientName,
  onConfirm,
  loading = false,
}) => {
  const reminderTitle = buildManualReminderTitle(noticeTitle);
  const singleRecipient = recipientName?.trim();

  return (
    <ActionModal
      open={open}
      onClose={onClose}
      title="Send reminder"
      subtitle={
        singleRecipient
          ? `Reminder for ${singleRecipient}`
          : "Publishes a new notice to the same audience"
      }
      maxWidth="sm"
      footer={
        <Box
          sx={{
            display: "flex",
            justifyContent: "flex-end",
            gap: 2,
            flexWrap: "wrap",
          }}
        >
          <NoticeboardButton variant="secondary" onClick={onClose} disabled={loading}>
            Cancel
          </NoticeboardButton>
          <NoticeboardButton
            variant="primary"
            onClick={onConfirm}
            loading={loading}
          >
            Send reminder
          </NoticeboardButton>
        </Box>
      }
    >
      <Typography variant="body1" sx={{ mb: 2, lineHeight: 1.6 }}>
        This will send a new notice with the title{" "}
        <Typography component="span" fontWeight={600}>
          "{reminderTitle}"
        </Typography>{" "}
        {singleRecipient ? (
          <>
            to <Typography component="span" fontWeight={600}>{singleRecipient}</Typography> only.
          </>
        ) : (
          <>to the same parents and students as the original.</>
        )}
      </Typography>
      <Typography variant="body2" color="text.secondary" sx={{ lineHeight: 1.6 }}>
        The message will begin with: "{MANUAL_REMINDER_BODY_INTRO}" followed by
        the original notice text. Push notifications will be sent immediately.
      </Typography>
    </ActionModal>
  );
};

export default SendReminderModal;
